export default __webpack_public_path__ + "static/media/building.5bdcebe8.svg";